import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { IStateMastDropdown } from "../../../models/IDropdown";

export interface ICity {
    city_ID?: number,
    state_ID?: number,
    state?: IStateMastDropdown,
    city_Name?: string,
    state_Name?: string,
    country_Name?: string,
    description?: string
}
export const EmptyCity: ICity = {
    city_ID: undefined,
    state_ID: 0,
    state: { state_ID: 0, state_Name: "" },
    city_Name: "",
    description: ""
}

export interface IModel {
    open: boolean,
    singleData: ICity
}

export const City = ({ setTab }: { setTab: (tab: number) => void }) => {

    const [modal, setModal] = useState({ singleData: EmptyCity, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyCity, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table setTab={setTab} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
